const translations = {
    applicationData: 'Application Data',
    title: 'Flight Overview'
};

export default translations;
